import '../styles/Contacto.css'

const Contacto = () => {
    return (
        <>
            <div className='home p-0' id="contacto"> 
            
                <div className='container-cookie bannerInicial'>
                    <div className='row bannerI'>
                        <div className='col-12 col-md-6 col-image p-0'>
                            <div className='home__image-container'>
                                <img src='/assets/img/homeout/img-contacto.png' className="home__image_desks" alt='' />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 col-back'>
                            <div className='home__text-container container__contacto'>
                            <h2 className='color_azul mb-3 py-3 mt-4 tituloContacto text-center text-md-start'>Contáctanos</h2>
                                <div className="card__contacto-item">
                                    <div className="card__contacto-img d-none d-lg-block">
                                        <img src='/assets/img/homeout/contacto/ico-fono.svg' alt="icono_telefono" className="d-none d-lg-block" style={{'marginTop':'-8px'}}/>
                                    </div>
                                    <div className='div__telefono text-center text-md-start'>
                                        <p className="card__contacto-description">Si tienes alguna inquietud o consulta, comunícate con nosotros en nuestra línea de atención en:</p><br/>
                                        <p className="card__contacto-description color_morado_light d-none d-lg-block">Línea de atención Cardif: <a href='tel:800 953 0424'>800 953 0424</a><br/><div className='breakLine'></div>Horarios de atención: <br></br>Lunes a domingo de 09:00 a 21:00 hrs.</p>
                                        <p className="card__contacto-description color_morado_light d-block d-lg-none">Línea de atención Cardif: <br></br><a href='tel:800 953 0424'>800 953 0424</a><br/><div className='breakLine'></div>Horarios de atención: <br></br>Lunes a domingo de 09:00 a 21:00 hrs.</p>
                                    </div>
                                </div>
                                <div className="card__contacto-item">
                                    <div className="card__contacto-img d-none d-lg-block">
                                        <img src='/assets/img/homeout/contacto/ico-correo.svg' alt="icono_correo" className="d-none d-lg-block" style={{'marginTop':'-8px'}}/>
                                    </div>
                                    <div className=' text-center text-md-start'>
                                        <p className="card__contacto-description text-center text-md-start">También puedes escribirnos a nuestro correo electrónico:</p><br/>
                                        <p className="card__contacto-description color_morado_light"><a href='mailto:sac_mx@cardif.com.mx'>sac_mx@cardif.com.mx</a></p>
                                    </div>
                                </div>
                                {/* <div className="card__contacto-item">
                                    <div className="card__contacto-img d-none d-lg-block">
                                        <img src='/assets/img/homeout/contacto/ico-importante.svg' alt="icono_importante" />
                                    </div>
                                    <div>
                                        <p className="card__contacto-description"><b>Importante</b></p><br/>
                                        <p className="card__contacto-description">En ningún momento Cardif Seguros te solicitará información financiera ni personal, si recibes algún mensaje solicitando está información comunícate con nuestras líneas de atención.</p>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contacto